/* */ 
require('../../modules/es6.object.assign');
module.exports = require('../../modules/$.core').Object.assign;
